import { getAllSpecialAnnouncements } from "@services/specialAnnouncements";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

interface Options extends UseQueryOptions {
  params?: Record<string, any>;
}

export const useAllSpecialAnnouncements = (options: Options = {}) => {
  const { params, ...rest } = options;
  return useQuery<any>({
    queryKey: ["specialAnnouncements", params],
    queryFn: () => getAllSpecialAnnouncements(params),
    ...rest,
  });
};
